import React from "react";
import "../../asset/css/footer.css";
import { FadeInWrapper, images } from "../../action/customFn";
import { NavLink } from "react-router-dom";
import {
  LocMarkY,
  MessageIconY,
  PhoneIconY,
  RightArrowW,
} from "../../asset/icons/Icons";
import { FaXTwitter } from "react-icons/fa6";

const Footer = () => {
  return (
    <footer className="main-footer">
      <div
        className="bg-image zoom-two"
        style={{ backgroundImage: `url(${images["footer.jpg"]})` }}
      ></div>

      <div className="widgets-section">
        <div className="container">
          <div className="row">
            <div className="footer-column col-xl-3 col-lg-12 col-md-6 col-sm-12">
              <div className="footer-widget about-widget">
                <div className="logo">
                  <NavLink to="/">
                    <img
                    style={{width:"170px"}}
                      src={images["Metbrains_logo_shadow.png"]}
                      className="footer_logo_img"
                      alt=""
                    />
                  </NavLink>
                </div>
                <div className="text">
                  Connecting Minds <br /> Inspiring Knowledge!
                </div>
                <ul className="social-icon-two">
                  <li>
                    <NavLink
                      to="https://twitter.com/metbrains"
                      target="_blank"
                    >
                      <FaXTwitter />
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="#"
                      target="_blank"
                    >
                      <img src={images["ffacebook.png"]} alt="" />
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="https://www.linkedin.com/company/metbrains-inc/"
                      target="_blank"
                    >
                      <img src={images["flinkedin.png"]} alt="" />
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="https://www.instagram.com/metbrains?igsh=MXAyOXhxejVydDY3Mw%3D%3D&utm_source=qr"
                      target="_blank"
                    >
                      <img src={images["finsta.png"]} alt="" />
                    </NavLink>
                  </li>
                </ul>
              </div>
            </div>

            <div className="footer-column col-xl-2 col-lg-4 col-md-6 col-sm-12">
              <div className="footer-widget">
                <h4 className="widget-title">Explore</h4>
                <ul className="user-links">
                  <li>
                    <NavLink to="/about">About</NavLink>
                  </li>
                  <li>
                    <NavLink to="/contact-us">Contact us</NavLink>  
                  </li>
                  <li>
                    <NavLink to="/reviews">Reviews</NavLink>
                  </li>
                  
                </ul>
              </div>
            </div>

            <div className="footer-column col-xl-2 col-lg-4 col-md-6 col-sm-12">
              <div className="footer-widget">
                <h4 className="widget-title">Links</h4>
                <ul className="user-links">
                  
                  <li>
                    <NavLink to="/download-brochures">
                      Download Brochures
                    </NavLink>
                  </li>
                  <li>
                   <NavLink to="/reviews">Placed Candidates</NavLink>
                  </li>
                  <li>
                   <NavLink to="/mentor-application-form">Teach on Metbrains</NavLink>
                  </li>
                </ul>
              </div>
            </div>

            <div className="footer-column col-xl-5 col-lg-4 col-md-6 col-sm-12">
              <div className="footer-widget contact-widget">
                <h4 className="widget-title">Contact</h4>
                <div className="widget-content">
                  <ul className="contact-info">
                    <li>
                      <PhoneIconY />
                      <NavLink to="tel:+917694842008">+44 7897035008 </NavLink>
                    </li>
                    <li>
                      <MessageIconY />
                      <NavLink to="mailto:hello@MetBrains.in">
                        team@metbrains.com
                      </NavLink>
                    </li>
                    <li>
                      <LocMarkY />
                      <NavLink to={"#"}>US | UK | EU | Australia</NavLink>
                    </li>
                  </ul>
                  <div className="subscribe-form">
                    <form id="newsletter_form">
                      <div className="form-group">
                        <input
                          type="email"
                          name="email"
                          className="email"
                          value=""
                          placeholder="Email Address"
                          required
                          id="newsletter_inp"
                        />
                        <button
                          type="button"
                          className="theme-btn btn-style-one"
                        >
                          <RightArrowW />
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="auto-container">
          <div className="inner-container">
            <div className="copyright-text">
              By continuing past this page you agree to our{" "}
              <NavLink to="/terms-and-conditions">Terms and Conditions</NavLink>{" "}
              | <NavLink to="/privacy-policy">Privacy policy</NavLink> |{" "}
              <NavLink to="/refund-policy">
                Refund and Cancellation Policy
              </NavLink>{" "}
              . All trademarks are properties of their respective owners.
              {new Date().getFullYear()} © MetBrains
              Private Limited All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
